module.exports = __webpack_public_path__ + "157e1e6bf8f80ba15b723fdc844482b7.svg";